import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import { getBroadcastAction } from 'slices/broadcast'
import { isEqual } from 'lodash'

const useSingleBroadcast = () => {
	const { id } = useParams<{ id: string }>()

	const reduxState = useAppSelector(state => state.broadcast, isEqual)

	const dispatch = useAppDispatch()

	const { loading, broadcast } = reduxState

	const refresh = () => {
		if (id) {
			dispatch(getBroadcastAction({ id }))
		}
	}

	useEffect(() => {
		if (!broadcast && !loading) {
			refresh()
		}
		if (broadcast && broadcast._id !== id) {
			refresh()
		}
	}, [loading, broadcast])

	return { ...reduxState, id, refresh }
}

export default useSingleBroadcast
